import React, { FC } from 'react'
import { Avatar as ChakraAvatar, AvatarProps } from '@chakra-ui/react'

/**
 * Avatar component page.
 * @return {JSX.Element} Avatar component.
 */
export const Avatar: FC<AvatarProps> = props => {
  return (
    <ChakraAvatar
      alt="avatar"
      borderRadius={'xl'}
      height={'full'}
      width={'full'}
      {...props}
    />
  )
}
